module.exports = __webpack_public_path__ + "static/media/5125412361595601822.07dccf2c.svg";